<template>
  <v-card v-if="this.$mmconfig.allowUserRegistration">
    <v-card-title class="headline grey lighten-2">
      {{ $t('login.createAccount') }}
    </v-card-title>

    <v-card-text>
      <div class="w-full max-w-xs mx-auto">
        <form @submit.prevent="register()" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <v-text-field
            v-model="form.username"
            :label="$t('login.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.password"
            :label="$t('login.password')"
            :hint="$t('login.passwordHint')"
            counter
            type="password"
            required
          ></v-text-field>
          <v-text-field            
            v-model="rePassword"
            :rules="[passwordConfirmationRule]"
            type="password"
            :label="$t('login.reenterPassword')"
            counter
            required
          ></v-text-field>
          <v-text-field
            v-model="form.email"
            :label="$t('login.email')"
            type="email"
            required
          ></v-text-field>
          <v-text-field            
            v-model="reEmail"
            :rules="[emailConfirmationRule]"
            type="email"
            :label="$t('login.reenterEmail')"
            required
          ></v-text-field>
          <v-row
            align="center"
            justify="space-around"
          >
            <v-btn
              type="submit"
              color="info">
              {{ $t('login.createAccount') }}
            </v-btn>
          </v-row>
        </form>
        <v-row
          align="center"
          justify="space-around"
        >
          <a v-if="this.$mmconfig.allowUserLogin" href="#" @click="$emit('switchTab', 'login')">
            {{ $t('login.alreadyRegistered') }}
          </a>
          <a v-if="this.$mmconfig.allowPasswordReset" href="#" @click="$emit('switchTab', 'resetPassword')">
            {{ $t('login.forgotPassword') }}
          </a>
        </v-row>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="$emit('close')"
      >
        {{ $t('base.close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        form: {
          username: '',
          password: '',
          email:    '',
        },
        rePassword: '',
        reEmail:    '',
      }
    },
    methods: {
      async register() {
        return new Promise((resolve) => {
          axios.post(`http://koku-dev.regional-digital-sh.de/wp-json/wp/v2/users/register`, this.form).then((response) => {
            if(response.data.code === 200) {
              console.log(response.data)
              this.$store.dispatch('message', { content: this.$i18n.t('login.registrationSuccess'), color: 'success' })
              this.$emit('switchTab', 'login')
            } else {
              this.$store.dispatch('message', { content: this.$i18n.t('login.registrationFailure'), color: 'error' })
              this.$emit('close')
            }
            resolve()
          }).catch(() => {
            this.$store.dispatch('message', { content: this.$i18n.t('login.registrationFailure'), color: 'error' })
            this.$emit('close')
          })
        })
      }
    },
    computed: {
      passwordConfirmationRule() {
        return () => (this.form.password === this.rePassword) || this.$t('login.passwordMatch')
      },
      emailConfirmationRule() {
        return () => (this.form.email === this.reEmail) || this.$t('login.emailMatch')
      }
    }
  }
</script>